import { resolvePostBlogCategory } from './blogCategories';

/** Sort blog posts newest first for list views */
export function sortPostsByDate(posts) {
  return [...posts].sort((a, b) => {
    const ta = new Date(a.publishedAt || 0).getTime();
    const tb = new Date(b.publishedAt || 0).getTime();
    return tb - ta;
  });
}

/** Position drill guides (non-wellness exercise posts) */
export function isSkillTrainingGuide(post) {
  return resolvePostBlogCategory(post) === 'exercise' && !post?.wellnessMeta;
}
